import { render, staticRenderFns } from "./BeneficiaryBadgeCreateEditModal.vue?vue&type=template&id=fd904b14&scoped=true"
import script from "./BeneficiaryBadgeCreateEditModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryBadgeCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd904b14",
  null
  
)

export default component.exports